<div class="session-expired">
    <div class="session-expired__body">
        <span class="session-expired__icon" aria-hidden="true">
            <mat-icon>lock_clock</mat-icon>
        </span>

        <div class="session-expired__text">
            <h2 mat-dialog-title [id]="titleId" class="session-expired__title heading-4">Session expired</h2>
            <p class="session-expired__message body-0">Your session has expired.<br />Please sign in again to continue.</p>
        </div>
    </div>

    <div class="session-expired__actions">
        <button
            mat-raised-button
            cdkFocusInitial
            color="primary"
            type="button"
            [disabled]="isRedirecting()"
            (click)="onSignIn()"
        >
            Sign in again
        </button>
    </div>
</div>
